import { ManagedPermission } from "./ManagedPermission";

/**
 * Initialises cache of Managed Permissions and provides centralised access to them
 */
export class PermissionsManager {
  private static permissionsRegistry: Record<string, ManagedPermission> = {};

  static async registerManagedPermissions(
    managedPermissions: ManagedPermission[]
  ) {
    const promises = managedPermissions.map((permission) => {
      return permission.getPermissionResponse().then((_initialised) => {
        return this.registerManagedPermission(permission.token, permission);
      });
    });

    return Promise.all(promises);
  }

  static getManagedPermission(moduleName: string): ManagedPermission {
    const managedPermission =
      PermissionsManager.permissionsRegistry[moduleName];
    if (!managedPermission) {
      throw new Error(`No managed permissions for module ${moduleName}`);
    }
    return managedPermission;
  }

  static registerManagedPermission(
    moduleName: string,
    permissions: ManagedPermission
  ) {
    PermissionsManager.permissionsRegistry[moduleName] = permissions;
  }

  /**
   * Check if permission has been granted previously
   */
  static hasPermission(moduleName: string): boolean {
    return PermissionsManager.getManagedPermission(moduleName).isPermitted;
  }
}
